export enum LoomDeletePolicy {
  NONE = 'NONE',
  SCHEDULE_WOVEN = 'SCHEDULE_WOVEN',
  TIME_PERIOD = 'TIME_PERIOD'
}
